// @flow

import { useEffect, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { not, or } from 'ramda'

import { changeGuestAccessTTL } from '@alphaott/app-core/actions'
import { getGuestAccessTrialEnabled } from '@alphaott/app-auth/selectors'
import { getCustomerGuestMode, getGuestAccessTrialExpires } from '@alphaott/app-core/selectors'
import { useTimer } from '@alphaott/common-utils'
import { GUEST_ACCESS_TIMER_STEP } from '@alphaott/app-config'

export const useGuestAccessTimer = () => {
  const dispatch = useDispatch()

  const isGuestCustomer = useSelector(getCustomerGuestMode)
  const isTrialEnabled = useSelector(getGuestAccessTrialEnabled)
  const trialExpires = useSelector(getGuestAccessTrialExpires)

  const isAvailableTimer = useMemo(() => isTrialEnabled && trialExpires, [isTrialEnabled, trialExpires])

  const handleChangeTTL = useCallback((expires: number) => dispatch(changeGuestAccessTTL({ expires })), [dispatch])

  const { start: timerStart, stop: timerStop, isRunning } = useTimer({
    expireTime: or(trialExpires, 0),
    step: GUEST_ACCESS_TIMER_STEP,
    onUpdate: handleChangeTTL,
  })

  // Start timer after customer authorization
  useEffect(() => {
    if (isAvailableTimer && not(isRunning)) {
      timerStart()
    }
  }, [isAvailableTimer]) // eslint-disable-line react-hooks/exhaustive-deps

  // Stop timer if there is no guest customer or guest customer token expired
  useEffect(() => {
    if (not(isGuestCustomer) && isRunning) {
      timerStop()
    }
  }, [isGuestCustomer]) // eslint-disable-line react-hooks/exhaustive-deps
}

export default useGuestAccessTimer
